import { LoadingPage } from "../LoadingPage";
import { Navigation } from "../Navigation";
import { Countdown } from "../../Components/Countdown";
import "./mint.css";

const mintItems = [
  {
    id: "schizo-sybils",
    name: "Schizo Sybils",
    description:
      "Schizo Sybils is a hivemind cult born to immortalize the Sybil-Spam Era of bArtio testnet. The 1337 NFT PFPs are a love letter to the Community, who were in the trenches everyday, grinding the testnet as well as begging for tips and useless discord roles in the hopes of getting rich on a fake chain. Schizo Sybils is a magical place where everyone can be their (favorite) self.",
    card_image: "/images/mint/schizo-sybils.png",
    supply: "1337 mintable",
    price: "Paid $20",
    mint_timestamp: "1737820800",
    url: "",
    twitter: "https://x.com/schizosybils",
    discord: "https://discord.gg/schizosybils",
    category: "kingdomly",
  },
  {
    id: "-genesis-stars",
    name: "Genesis Stars",
    description:
      "A limited collection of NFTs representing the founding members of Tierra's ecosystem. Each Genesis Star grants holders exclusive privileges and welcomes them as early members of our community.",
    card_image:
      "https://www.kingdomly.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fkingdomly-appv2.appspot.com%2Fo%2Fprojects%252F315QRPyAe0UGfFaREKRy%252Fmint_page%252Fcard_img.webp%3Falt%3Dmedia%26token%3Dc42289be-3b16-4f07-ab91-3df6fafae37a&w=1080&q=100",
    supply: "411 mintable",
    price: "Free Mint",
    mint_timestamp: "1736526000",
    url: "https://tierraproject.io",
    twitter: "https://x.com/tierra_io",
    discord: "https://discord.com/invite/tierra",
    category: "kingdomly",
  },
  {
    id: "turtle-berachain-badge",
    name: "Turtle BeraChain Badge",
    description:
      "Turtle BeraChain Badge, is an exclusive NFT drop to kick off Q5 in style. This badge is for the OGs, the beras, and the frens who’ve been with us as we grow the Turtle Club ecosystem. &nbsp;Benefits:Exclusive Role.Early Access.&nbsp;[REDACTED] Rewards.Extra Clout.",
    card_image:
      "https://www.kingdomly.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fkingdomly-appv2.appspot.com%2Fo%2Fprojects%252FLYRrf7sYScvWr0QvAc6f%252Fmint_page%252Fcard_img.webp%3Falt%3Dmedia%26token%3Df91d4350-cbd3-4dd7-84cc-7405fb51ff36&w=1080&q=100",
    supply: "6900 mintable",
    price: "Free Mint",
    mint_timestamp: "1737130800",
    url: "https://turtle.club",
    twitter: "https://x.com/turtleclubhouse",
    discord: "https://discord.com/invite/WRY7C7TWn2",
    category: "kingdomly",
  },
  {
    id: "bullas",
    name: "Bullas",
    description:
      "Bullas NFT is the first project to mint on Magic Eden after Berachain’s mainnet launch, with a total supply of 6969, combining a fun farming game with ecosystem token rewards.",
    card_image: "/images/mint/bullas.png",
    supply: "6969 mintable",
    price: "TBD",
    mint_timestamp: "",
    url: "https://bullas.xyz",
    twitter: "https://x.com/TheBullas_",
    discord: "https://discord.com/invite/bullas",
    category: "magic",
  },
];

export const MintPage = () => {
  return (
    <>
      <div className={"mint page-content loaded left-nav-sidebar"}>
        <Navigation name="mint" />
        <section className="local-no-padding md-padding-80px-top xs-padding-80px-top sm-padding-80px-top">
          <div className="mint-container">
            {mintItems.map((item, index) => {
              return (
                <div key={index} className="blog-slider">
                  <div className="blog-slider__wrp swiper-wrapper">
                    <div className="blog-slider__item swiper-slide swiper-slide-active">
                      <div className="blog-slider__img bg-white-opacity">
                        <img src={item.card_image} alt={item.name} />
                        <div className="portfolio-icon">
                          {item.category === "kingdomly" ? (
                            <a
                              className="cursor-pointer"
                              href={"https://www.kingdomly.app/" + item.id}
                              title="Kindomly"
                              target="_blank"
                            >
                              <img
                                className="!w-[32px] !h-full mt-[20px] portfolio-icon-kindomly cursor-pointer"
                                src="/images/kingdomly.png"
                                alt="Kindomly"
                              />
                            </a>
                          ) : (
                            ""
                          )}
                          {item.url !== "" ? (
                            <a
                              href={item.url}
                              title={item.name}
                              target="_blank"
                            >
                              <i className="fas fa-link" aria-hidden="true"></i>
                            </a>
                          ) : (
                            ""
                          )}
                          {item.twitter !== "" ? (
                            <a
                              href={item.twitter}
                              title="Twitter"
                              target="_blank"
                            >
                              <i
                                className="fab fa-twitter"
                                aria-hidden="true"
                              ></i>
                            </a>
                          ) : (
                            ""
                          )}
                          {item.discord !== "" ? (
                            <a
                              href={item.discord}
                              title="Discord"
                              target="_blank"
                            >
                              <i
                                className="fab fa-discord"
                                aria-hidden="true"
                              ></i>
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="blog-slider__content">
                        <div className="blog-slider__title">
                          {item.category === "kingdomly" ? (
                            <a
                              href={"https://www.kingdomly.app/" + item.id}
                              target="_blank"
                            >
                              {item.name}
                            </a>
                          ) : (
                            <a
                              href={"https://magiceden.io/launchpad"}
                              target="_blank"
                            >
                              {item.name}
                            </a>
                          )}
                        </div>
                        <div className="blog-slider__text">
                          {item.description}
                        </div>
                        {item.category === "kingdomly" ? (
                          <a
                            className="blog-slider__supply"
                            href={"https://www.kingdomly.app/" + item.id}
                            target="_blank"
                          >
                            {item.supply} - {item.price}
                          </a>
                        ) : (
                          <a
                            className="blog-slider__supply"
                            href={"https://magiceden.io/launchpad"}
                            target="_blank"
                          >
                            {item.supply} - {item.price}
                          </a>
                        )}
                        <div className="blog-slider__countdown">
                          {item.mint_timestamp !== "" ? (
                            <Countdown time={Number(item.mint_timestamp)} />
                          ) : (
                            <span className="text-[18px] text-[#fb8500] font-[700]">
                              after mainnet
                            </span>
                          )}
                        </div>
                        <div className="blog-slider__logo_container">
                          <p>Mint in </p>
                          {item.category === "kingdomly" ? (
                            <a
                              className="blog-slider__mint_logo"
                              href={"https://www.kingdomly.app/" + item.id}
                              target="_blank"
                            >
                              <img src="/images/kingdomly.png" />
                            </a>
                          ) : (
                            <a
                              className="blog-slider__mint_logo"
                              href={"https://magiceden.io/launchpad"}
                              target="_blank"
                            >
                              <img src="/images/mint/magiceden.png" />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </>
  );
};
